import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const loadBuildId = async () => {
  try {
    const response = await fetch('/api/health', { cache: 'no-store' });
    const payload = await response.json();
    return payload.app_build_id || 'static';
  } catch {
    return 'static';
  }
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    loadBuildId().then((buildId) => {
      window.__VENULOQ_BUILD_ID__ = buildId;
      navigator.serviceWorker.register(`/sw.js?build=${encodeURIComponent(buildId)}`).catch(() => {
        // PWA shell install/update is best-effort only.
      });
    });
  });
}
